import React from 'react'
import SignIn from 'pages/Home/SignIn'

import styles from './static.module.scss'

const Forbiden = () => {
  return (
    <div className={styles.forbidenComntainer}>
      <div className={styles.errorCodeContainer}>
        <div className={styles.errorCode}>403</div>
        <div className={styles.errorMessage}>
          Access forbiden , please login to access this page.
        </div>
      </div>
      <div className={styles.signIn}>
        <SignIn />
      </div>
    </div>
  )
}

export default Forbiden
